import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Typography, Divider, TextField, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Snackbar, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { deleteProductAssetLinkAPI } from './DesignMgmtAPI';
import { deleteProductassetObj, setProductassetList, setProductSelectImageModal, updateProductObj } from 'store/slice/PharmaSlice';
import { setImageType } from 'store/slice/ImageGallerySlice';
import { getProductassetInfoByProductidandtypeAPI } from '../../../productasset/ProductassetAPI';
import SelectImageActionModal from '../selectImage/SelectImageActionModal';
import ImageIcon from '@mui/icons-material/Image';
import { deleteAPI } from '../../../productasset/ProductassetAPI';
import Alert from '@mui/material/Alert';
import { setSelectedAssetIdList } from 'store/slice/ImageGallerySlice';
import { submitDesignQaApprovalAPI } from 'api/OmsOrdermgmtWebServices';
import CustomerApprovedDesign from './CustomerApprovedDesign';
import { setSnackbarMessage, setSnackbarOpen } from 'store/slice/AppSlice';
import { getAssetcommentsInfoByProductidAPI } from '../../../assetcomments/AssetcommentsAPI';
import DesignerUploadQADesign from './DesignerUploadQADesign';


export default function DesignerReviewQAComments() {
    const dispatch = useDispatch();
    const { selectedImagePath, selectedImage, imageType } = useSelector((state) => state.imagegalleryslice);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const { productassetList } = useSelector((state) => state.pharmaslice);
    const [approvalDate, setApprovalDate] = useState('');
    const [viewImage, setViewImage] = useState(null); // {src, name}
    const [deleteDialog, setDeleteDialog] = useState({ open: false, assetObj: null });
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [radioDateError, setRadioDateError] = useState(false);
    const {assetList} = useSelector((state) => state.imagegalleryslice);
    const {snackbarOpen, snackbarMessage} = useSelector((state) => state.appslice);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [qaReviewedAssets, setQaReviewedAssets] = useState([]);
    const [assetComments, setAssetComments] = useState([]);

    useEffect(() => {
        dispatch(setImageType("QA"));
        
    },[]);
    

    useEffect(() => {
        if (productassetList && productassetList.length > 0) {
            dispatch(
                setSelectedAssetIdList(
                    productassetList
                        .filter(obj => obj.imagetype === "QA")
                        .map(obj => obj.assetid)
                        .join(',')
                )
            );
            setQaReviewedAssets(
                productassetList.filter(obj => obj.imagetype === "QA" &&   obj.designstatus !== "")
            );
        }
    }, [productassetList]);
    const fetchLinkedAssetSuccessCallBack = (responseObj) => {
        //dispatch(setSelectedAssetObjList(responseObj));
        dispatch(setProductassetList(responseObj));
        dispatch(setSelectedAssetIdList(responseObj.map(obj => obj.assetid).join(',')));
        
    };
    
    useEffect(() => {
        getProductassetInfoByProductidandtypeAPI( "QA",productObj.id, () => { }, fetchLinkedAssetSuccessCallBack)
    }, [])

    const deleteProductAssetLinkSuccessCallBack = (responseObj) => {
        dispatch(deleteProductassetObj(responseObj.id));
    };
    
    const submitForQAApproval = () => {
        submitDesignQaApprovalAPI(
            {
                "productId": productObj.id
            },
            (response) => {
                dispatch(setSnackbarMessage("Submitted for QA approval successfully."));
                dispatch(setSnackbarOpen(true));
                dispatch(setProductSelectImageModal(false));
                dispatch(updateProductObj(response.productInfo));
            },
            (error) => {
                console.error("Error submitting for QA approval:", error);
                dispatch(setSnackbarMessage("Error submitting for QA approval."));
                dispatch(setSnackbarOpen(true));
            }
        );
        // You can also dispatch any other actions if needed
    }
    // Filter customer approved images
    const AssetForQAApproval = productassetList.filter((asset)=>asset.imagetype=== "QA")
        
    const confirmDelete = () => {
        if (deleteDialog.assetObj) {
            deleteAPI(deleteDialog.assetObj.id, () => {
                dispatch(deleteProductassetObj(deleteDialog.assetObj.id));
                setDeleteDialog({ open: false, assetObj: null });
                setViewImage(null);
                dispatch(setSnackbarMessage("Asset delinked successfully."));
                dispatch(setSnackbarOpen(true));
            });
        }
    };

    const cancelDelete = () => {
        setDeleteDialog({ open: false, assetObj: null });
    };

    const isQAReadOnly = productObj?.designstatusqa === 'DESIGN WITH QA';

    // Fetch comments for all assets of this product
    useEffect(() => {
        if (productObj?.id) {
            getAssetcommentsInfoByProductidAPI(productObj.id, (response) => {
                setAssetComments(response || [])},
                ()=>{}
            );
        }
    }, [productObj?.id]);

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    
                    overflow: 'hidden',
                    backgroundColor: 'secondary.100',
                    position: 'relative',
                }}
            >
                <Grid
                    container
                    justifyContent="space-between"
                    sx={{
                        height: '100%',
                        width: '100%',
                        margin: 0,
                        flexWrap: { xs: 'wrap', md: 'nowrap' },
                        overflow: 'hidden',
                        columnGap: 2, // <-- Add this line for 2px gap between columns
                    }}
                >
                    {/* Section 1: Customer Approved Design */}
                    <Grid
                        item
                        lg={8}
                        xs={12}
                        sm={3}
                        md={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                            mt: { xs: 0, md: 0 }, 
                        }}
                    >
                        
                                
                    <Box
                            sx={{
                                backgroundColor: 'white',
                                borderRadius: 2,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                border: '1px solid #e0e0e0',
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    mb: 1,
                                    backgroundColor: 'primary.lighter',
                                    p:1
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 'bold',
                                        px: 2,
                                        py: 1,
                                        borderRadius: 1,
                                        display: 'inline-block'
                                    }}
                                >
                                    QA Reviewed Assets
                                </Typography>
                                
                            </Box>
                            <Divider sx={{}} />
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    borderRadius: 2,
                                    overflowY: 'auto',
                                    backgroundColor: 'white',
                                    height: '100%',
                                    maxHeight: { lg: '58vh', md: '60vh', sm:'60vh', xs: '40vh',  }, // Add a maxHeight for scrolling
                                }}
                            >
                                <Grid container sx={{ width: '100%' }} justifyContent="space-between" alignItems="flex-start">
                                    {qaReviewedAssets.length > 0 ? qaReviewedAssets.map(productAssetObj => {
                                        // Filter comments for this asset only
                                        const commentsForAsset = assetComments.filter(
                                            c => c.assetid === productAssetObj.id
                                        );
                                        return (
                                            <Grid item key={productAssetObj.id} lg={12} md={12} sm={12} xs={12} sx={{ p: 1 }}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row', // image+status | comments
                                                        alignItems: 'flex-start',
                                                        p: 1,
                                                        borderRadius: 2,
                                                        backgroundColor: 'secondary.100',
                                                        // Remove border and boxShadow
                                                        // border: selectedImageId === productAssetObj.id ? '1px solid #0050b3' : '1px solid transparent',
                                                        // boxShadow: selectedImageId === productAssetObj.id ? 3 : 0,
                                                        cursor: 'pointer',
                                                        position: 'relative'
                                                    }}
                                                    onClick={() => setViewImage({ src: productAssetObj.assetpath, name: productAssetObj.name, id: productAssetObj.id })}
                                                    onMouseEnter={() => setSelectedImageId(productAssetObj.id)}
                                                    onMouseLeave={() => setSelectedImageId(null)}
                                                >
                                                    {/* First column: Status at top, then image and name */}
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center',  }}>
                                                        <Box
                                                            sx={{
                                                                background: 'white',
                                                                borderRadius: 1,
                                                                px: 2,
                                                                py: 0.5,
                                                                mb: 1,
                                                                width: '100%',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600 }}>
                                                                Status
                                                            </Typography>
                                                            <Typography variant="body2" color="primary" sx={{ fontWeight: 500 }}>
                                                                {productAssetObj.designstatus || 'N/A'}
                                                            </Typography>
                                                        </Box>
                                                        <img
                                                            src={productAssetObj.assetpath}
                                                            style={{
                                                                width: '250px',
                                                                height: '250px',
                                                                borderRadius: '8px',
                                                                cursor: 'pointer'
                                                            }}
                                                            alt={productAssetObj.name}
                                                        />
                                                        <Typography
                                                            variant="body2"
                                                            noWrap
                                                            title={productAssetObj.name}
                                                            sx={{
                                                                maxWidth: '120px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                display: 'block',
                                                                mt: 1,
                                                                color: '#1976d2',
                                                                textAlign: 'center',
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            {productAssetObj.name}
                                                        </Typography>
                                                    </Box>
                                                    {/* Second column: Comments */}
                                                    <Box sx={{ ml: 2, flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                                        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                                                            Comments
                                                        </Typography>
                                                        {commentsForAsset.length > 0 ? (
                                                            commentsForAsset.map((commentObj, idx) => (
                                                                <Box key={idx} sx={{ background: 'white', borderRadius: 1, p: 1, mb: 0.5, width: '100%' }}>
                                                                    {/* <Typography variant="caption" color="text.secondary">
                                                                        {commentObj.username || 'QA'}:
                                                                    </Typography> */}
                                                                    <Typography variant="body2" color="text.primary">
                                                                        {commentObj.title}
                                                                    </Typography>
                                                                </Box>
                                                            ))
                                                        ) : (
                                                            <Typography variant="caption" color="text.disabled">
                                                                No comments
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        );
                                    }) : (
                                        <Grid item xs={12} sx={{ padding: 5, minHeight: '200px', justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                                            <Typography variant="h5" color="text.secondary" sx={{ borderRadius: 5, padding: 10, backgroundColor: 'secondary.100' }}>
                                                
                                                Click on 'Asset Library' Button to Upload / Select Assets.
                                            </Typography>
                                            
                                        </Grid>
                                    )}
                                </Grid>
                            </Box>
                             
                        </Box>
                           
                    </Grid>
                    {/* Section 2: QA Images */}
                    <Grid
                        item
                        lg={4}
                        xs={12}
                        sm={12}
                        md={12}
                        sx={{

                        }}
                    >
                        <DesignerUploadQADesign/>
                    </Grid>

                    {/* Spacer: 5% */}
                    {/* <Grid
                    item
                    md={1}
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        flexBasis: { md: '5%' },
                        maxWidth: { md: '5%' }
                    }}
                /> */}

                    

                    {/* Image View Dialog */}
                    <Dialog
                        open={!!viewImage}
                        onClose={() => setViewImage(null)}
                        maxWidth={false}
                        PaperProps={{
                            sx: {
                                width: 'auto',
                                maxWidth: '90vw',
                                minWidth: '320px',
                                p: 0,
                                borderRadius: 2,
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, pb: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                {viewImage?.name || "Image"}
                            </Typography>
                            <IconButton onClick={() => setViewImage(null)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Divider />
                        <DialogContent
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                p: 3,
                                minWidth: '320px',
                                minHeight: '200px',
                                maxWidth: '80vw',
                                maxHeight: '70vh',
                            }}
                        >
                            <img
                                src={viewImage?.src}
                                alt={viewImage?.name}
                                style={{
                                    //maxWidth: '70vw',
                                    //maxHeight: '60vh',
                                    display: 'block',
                                    margin: '0 auto'
                                }}
                            />
                        </DialogContent>
                        <Divider />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: 2, pt: 1 }}>
                            {(viewImage?.id && (
                                // Find the asset object for the current viewImage
                                (productassetList.find(a => a.id === viewImage.id)?.designstatus === '' ||
                                 productassetList.find(a => a.id === viewImage.id)?.designstatus == null)
                            )) && (
                                <Button
                                    onClick={() => setDeleteDialog({ open: true, assetObj: { id: viewImage?.id, assetpath: viewImage?.src, assetname: viewImage?.name } })}
                                    color="error"
                                    variant="contained"
                                    startIcon={<DeleteIcon />}
                                    disabled={isQAReadOnly}
                                >
                                    De-link from Product
                                </Button>
                            )}
                        </Box>
                        {/* Delete Confirmation Dialog as modal over image dialog */}
                        <Dialog
                            open={deleteDialog.open}
                            onClose={cancelDelete}
                            maxWidth="xs"
                            PaperProps={{
                                sx: {
                                    zIndex: 1601, // higher than the image dialog
                                }
                            }}
                        >
                            <DialogTitle>Confirm Delink</DialogTitle>
                            <DialogContent>
                                <Typography>Are you sure you want to delink '{viewImage?.name || "Asset"}' from the Product?</Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={cancelDelete} color="primary">Cancel</Button>
                                <Button onClick={confirmDelete} color="error" variant="contained">De-link from Product</Button>
                            </DialogActions>
                        </Dialog>
                    </Dialog>



                    {/* Existing modal and other logic */}
                    <SelectImageActionModal />
                </Grid>
            </Box>
            
            
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={10000}
                onClose={() => dispatch(setSnackbarOpen(false))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Snackbar
                open={radioDateError}
                autoHideDuration={10000}
                onClose={() => setRadioDateError(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setRadioDateError(false)}
                    severity="error"
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    Please select a date before selecting customer approval
                </Alert>
            </Snackbar>

            {/* Confirmation Dialog */}
            <Dialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
                maxWidth="xs"
            >
                <DialogTitle>Confirm Submission</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to submit for QA Approval?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDialogOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            setConfirmDialogOpen(false);
                            submitForQAApproval();
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}